export default __webpack_public_path__ + "9b92d3b.png";